import React, { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useApiClient } from "../../../api";

export const MARKETING_UNSUBSCRIBE_REASONS = [
  ["not_interested", "No longer interested"],
  ["too_frequent", "Emails are too frequent"],
  ["not_relevant", "Emails are not relevant"],
  ["already_subscribed", "Already subscribed"],
  ["other", "Other"],
];

export const MarketingEmailPreferences = ({ user }) => {
  const ApiClient = useApiClient();
  const [reason, setReason] = useState("");
  const [detail, setDetail] = useState("");
  const [saving, setSaving] = useState(false);
  const [suppressed, setSuppressed] = useState(
    Boolean(user?.info?.marketingEmailSuppressed),
  );

  const unsubscribe = async () => {
    setSaving(true);
    try {
      const response = await ApiClient.users.unsubscribeFromMarketing({
        reason,
        detail,
      });
      if (!response?.success) throw new Error("Unsubscribe failed");
      setSuppressed(true);
      enqueueSnackbar(response.message, { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Unable to update your marketing email preference", {
        variant: "error",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card variant="shadow">
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h3">Marketing emails</Typography>
          {suppressed ? (
            <Typography color="text.secondary">
              You are unsubscribed from Fruitify marketing emails.
            </Typography>
          ) : (
            <>
              <Typography color="text.secondary">
                You can stop receiving onboarding and other marketing emails.
                Account and security emails will still be sent when needed.
              </Typography>
              <FormControl fullWidth>
                <InputLabel id="marketing-unsubscribe-reason-label">
                  Reason (optional)
                </InputLabel>
                <Select
                  labelId="marketing-unsubscribe-reason-label"
                  value={reason}
                  label="Reason (optional)"
                  onChange={(event) => setReason(event.target.value)}
                >
                  <MenuItem value="">Prefer not to say</MenuItem>
                  {MARKETING_UNSUBSCRIBE_REASONS.map(([value, label]) => (
                    <MenuItem key={value} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Anything else you would like us to know? (optional)"
                value={detail}
                onChange={(event) => setDetail(event.target.value)}
                multiline
                minRows={3}
                slotProps={{ htmlInput: { maxLength: 1000 } }}
              />
              <Button
                variant="outlined"
                onClick={unsubscribe}
                disabled={saving}
                sx={{ alignSelf: "flex-start" }}
              >
                {saving ? "Unsubscribing..." : "Unsubscribe"}
              </Button>
            </>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};
